import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[querySwitchGroup]',
  standalone: false,
})
export class QuerySwitchGroupDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[queryButtonGroup]',
  standalone: false,
})
export class QueryButtonGroupDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[queryRemoveButton]',
  standalone: false,
})
export class QueryRemoveButtonDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[queryField]',
  standalone: false,
})
export class QueryFieldDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[queryOperator]',
  standalone: false,
})
export class QueryOperatorDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[queryInput]',
  standalone: false,
})
export class QueryInputDirective {
  @Input() queryInputType?: string;

  constructor(public template: TemplateRef<any>) {}
}
